import React from "react";
import ThreeDots from "../skelliton/ThreeDots";

import "../styles/icon-button.scss";

export default function IconButton({
  icon,
  text,
  onClick,
  style,
  vertical,
  textStyle,
  loading,
}) {
  return (
    <React.Fragment>
      {!loading && (
        <div
          className="icon-button"
          style={{
            ...style,
            display: "flex",
            flexDirection: vertical ? "column" : "row",
          }}
          onClick={onClick}
        >
          {icon}
          {text && <span style={{ margin: 5, ...textStyle }}> {text}</span>}
        </div>
      )}
      {loading && <ThreeDots />}
    </React.Fragment>
  );
}
